import React, { Component,createRef } from 'react';
import { withRouter, setCookie, login_check, loginUrl, pocketUrl, LoadingSpinner, getCookie, deleteCookie, isLogin } from './include/Common';
import {Helmet} from 'react-helmet';

import $ from 'jquery';
import axios from "axios";
import { Navigate } from "react-router-dom";
import Swiper from 'swiper';
import 'swiper/css';
import Footer from './Footer';

//

class My extends Component {
   constructor(props) {
      super(props);
      this.popupRef = createRef();
      this.swiper = null;
      this.state = {
         isLogin: false,   // 처음에 로딩 상태
         loading: true,
         zzimList: [],

         userNick:'',
         newNick : '',
         userLvl:1,
         expCurr:0,
         expRemain:0,
         expPercent:0,
         currStartExp:0,
         nextStartExp:0,
         gapLevel:0,
         quizTotal:0,
         quizCount:0,
         quizPercent:0,
         crossTotal:0,
         crossCount:0,
         crossPercent:0,
         searchTotal:0,
         searchDateCnt:0,
         searchPercent:0,
         weekPoint:0,
         weekTotal:0,
         weekCount:0,
         weekPercent:0,
         expQuiz:0,
         expCross:0,
         expSearch:0,
         attends:[],
         attendAll:false,
      };
   }
   componentDidMount() {
      this.fetchAccessCheck();
      const popup = this.popupRef.current;

      if (popup) {
         popup.addEventListener("focusin", this.handleFocusIn);
         popup.addEventListener("focusout", this.handleFocusOut);
      }         
      const closeRenamePopup = () => {
         $('.rename__popup').hide();
         $('body').css('overflow', 'auto');
      };

      // ✅ 기존에 혹시 붙어있을 수 있으니 네임스페이스로 제거 후 재등록
      $(document).off('click.renamePopup');
      $(document).off('click.renamePopupClose');

      // ✅ 팝업 바깥 클릭 시 닫기 (문서 위임)
      $(document).on('click.renamePopup', '.rename__popup', (e) => {
         // popup__wrap 영역 밖 클릭만 닫기
         if ($(e.target).closest('.popup__wrap').length === 0) {
            closeRenamePopup();
         }
      });

      // ✅ X 버튼 클릭 시 닫기 (문서 위임)
      $(document).on('click.renamePopupClose', '.rename__popup .popup__close', (e) => {
         e.preventDefault();
         closeRenamePopup();
      });

      function closeComboBx() {
         $(".comboBx__btn").removeClass("active");
         $(".comboBx__list").stop().fadeOut(200);
      }
      
   }

   async fetchAccessCheck() {
      const loginCheck = await login_check();
      const getToday = () => {
         const today = new Date();
         const year = today.getFullYear();
         const month = String(today.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작
         const day = String(today.getDate()).padStart(2, '0');
         return `${year}-${month}-${day}`;
      };
      if (!loginCheck) {
         window.location.replace(loginUrl + '?ref=' + pocketUrl + '/My');
      }
      let pocketTodayQuizCookie = getCookie('pocketTodayQuiz');
      const publicUrl = process.env.PUBLIC_URL;
      let quizCrossUrl = publicUrl + '/api/setCrossAnswer.php?week=' + getToday() + '&word=' + pocketTodayQuizCookie + '&mode=quiz';
      if (
         pocketTodayQuizCookie !== undefined &&
         pocketTodayQuizCookie !== null &&
         pocketTodayQuizCookie !== ''
      ) {
         axios.get(quizCrossUrl).then(response => {
            if (response.data == 'OK' && pocketTodayQuizCookie) {
               deleteCookie('pocketTodayQuiz');
            }
         });
      }
  
      let quizWordUrl = publicUrl + '/api/getUserQuiz.php';
      let response = axios.get(quizWordUrl);

      let info = (await response).data.info;
      this.setState({
         isLogin: loginCheck,
         loading: false,
         zzimList: (await response).data.zzim,

         userNick:info.unick,
         userLvl:info.level,
         expCurr:info.expCurrent,
         expRemain:info.expRemain,
         expPercent:info.expPercent,
         currStartExp:info.currLevelStart,
         nextStartExp:info.nextLevelStart,
         gapLevel:info.gapLevel,
         quizTotal:info.quizTotal,
         quizCount:info.quizCount,
         quizPercent:info.quizPercent,
         crossTotal:info.crossTotal,
         crossCount:info.crossCount,
         crossPercent:info.crossPercent,
         searchTotal:info.searchTotal,
         searchDateCnt:info.searchDateCnt,
         searchPercent:info.searchPercent,
         weekPoint:info.weekPoint,
         weekTotal:info.weekTotal,
         weekTotalTxt:info.weekTotalTxt,
         weekCount:info.weekCount,  
         weekPercent:info.weekPercent,
         expQuiz:info.expQuiz,
         expCross:info.expCross,
         expSearch:info.expSearch,   
         attends:info.attends,     
         attendAll:info.attendAll, 
      });

   }
   handleFocusIn = () => {
      // iOS 키보드 올라올 때 body 스크롤 고정
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
   };

   handleFocusOut = () => {
      // 포커스 아웃 시 body 스크롤 복원
      document.body.style.position = "";
      document.body.style.width = "";
   };
   handleButtonClick = async (targetIdx) => {
      const element = document.getElementById(`btn-${targetIdx}`);
      const isActive = element.classList.contains('active');

      this.setState(prevState => {
         const foundIndex = prevState.zzimList.findIndex(item => item.idx === targetIdx);

         if (foundIndex === -1) {
            console.error(`idx ${targetIdx}에 해당하는 항목이 없습니다.`);
            return null;
         }
         const updated = [...prevState.zzimList];
         updated[foundIndex] = {
            ...updated[foundIndex],
            uzzim: !updated[foundIndex].uzzim
         };
         const after = updated[foundIndex].uzzim;
         let md = 'setZzim';
         if (!after) md = 'unsetZzim';
         try {
            const ret = setWord(md, targetIdx);
            if (ret == 'setZzim') {
               element.className = 'zzim active';
            } else {
               element.className = 'zzim';
            }
            this.fetchAccessCheck();
         } catch (err) {
            console.error('버튼 클릭 처리 실패:', err);
         }
         return { zzimList: updated };
      });

   };
   componentDidUpdate(prevProps, prevState) {
      if (
         prevState.zzimList !== this.state.zzimList &&
         this.state.zzimList.length >= 2
      ) {
         setTimeout(() => {
            const container = document.querySelector('.wordSwiper .swiper-container');
            if (container) {
               if (this.swiper) {
                  this.swiper.update(); // 이미 존재하면 업데이트만
               } else {
                  this.initSwiper(); // 처음이면 초기화
               }
            } else {
               console.warn('swiper-container가 아직 DOM에 없습니다.');
            }
         }, 50);
      }
   }
   componentWillUnmount() {
      $(document).off('click.renamePopup');
      $(document).off('click.renamePopupClose');
   }   
   initSwiper() {
      if (this.swiper) return; // 한 번만 초기화
      this.swiper = new Swiper(".wordSwiper .swiper-container", {
         speed: 1e3,
         grabCursor: true,
         loop: false,
         slidesPerView: "auto",
         centeredSlides: false,
         centeredSlidesBounds: true,
         spaceBetween: 16,
         observer: false,
         observeParents: false,

      })
   }

   handleLogoutClick = () => {
      window.location.href = 'https://user.asiae.co.kr/snslogin/PocketLogout.htm';
   }

   onClickAttend = (dayKey, dayYmd) => {
      console.log(dayKey);
      const item = this.state.attends?.[dayKey];

      if (item.attend) return;

      const url = `/api/setAttendCheck.php?mode=attend`;
      console.log(url);
      axios.get(url)
         .then(res => {
            const ret = String(res.data).split("|"); // OK|1|5

            if (ret[1] === "1") {
            const exp = ret[2] ?? "0";

            this.setState(prev => {
               const attends = { ...prev.attends };
               attends[dayKey] = { ...attends[dayKey], attend: true };
               return { attends };
            }, () => {
               this.showExpPopup(exp);
            });
            }
         })
         .catch(console.error);
   }; 

   onClickBonus = () => {
      console.log('a');
      if (!Object.values(this.state.attends).every(v => v.attend === true)) return;
      console.log('b');
      axios.get('/api/setAttendCheck.php?mode=atbonus')
         .then(res => {
            console.log(res.data);
            const ret = String(res.data).split("|");
            if (ret[1] === "1") {
               this.setState({ attendAll: true });
               this.showExpPopup(ret[2] ?? "0");
            }
         })
         .catch(console.error);
   };   
   showExpPopup = (exp) => {
      //console.log('showexpPopup:'+exp);
      const el = this.popupEl;
      const txt = this.popupTextEl;
      if (!el || !txt) return;

      // 숫자 그대로 출력
      txt.innerText = `+`+exp;

      // 강제로 보이기
      el.style.display = "block";
      el.style.visibility = "visible";
      el.style.opacity = "1";

      clearTimeout(this.popupTimer);

      this.popupTimer = setTimeout(() => {
         el.style.opacity = "0";
         el.style.visibility = "hidden";
         el.style.display = "none";
         this.fetchAccessCheck();
      }, 1200);
   };     
   onChangeNick = (e) => {
      // 앞뒤 공백 제거는 저장 시점에만 해도 되고,
      // 입력 중에도 막고 싶으면 여기서 처리해도 됨
      this.setState({ newNick: e.target.value });
   };
   setUserNick = (e) => {
      if (e) e.preventDefault(); // ✅ 새로고침 방지

      const nick = (this.state.newNick || "").trim();

      // 간단 검증
      if (nick.length < 2) {
         alert("닉네임은 2자 이상이어야 합니다.");
         return;
      }
      if (nick.length > 10) {
         alert("닉네임은 10자 이하로 입력해주세요.");
         return;
      }

      // ✅ API 주소/파라미터는 네 서버 규격에 맞게 수정
      const url = `/api/setUserNick.php?nick=${encodeURIComponent(nick)}`;
      console.log(url);
      axios.get(url)
         .then((res) => {
            // 예: "OK|1" 또는 "OK|1|메시지" 형태라고 가정
            console.log(res.data);
            const ret = String(res.data).split("|");

            if (ret[0] === "OK") {
               // 성공: 현재 닉네임 갱신 + 입력 초기화
               this.setState({ userNick: nick, newNick: "" });
               alert("닉네임이 수정되었습니다.");
               $('.rename__popup').hide();
               $('body').css('overflow', 'auto');
            } else {
               alert(ret[2] ?? "닉네임 수정에 실패했습니다.");
            }
         })
         .catch((err) => {
            console.error(err);
            alert("통신 오류가 발생했습니다.");
         });      
   }

   
   render() {
      const { loading, isLogin, zzimList , userNick, userLvl, expCurr, expRemain,expPercent,currStartExp, nextStartExp,gapLevel, quizTotal,quizCount,quizPercent,crossTotal,crossCount,crossPercent,searchTotal,searchDateCnt,searchPercent,weekPoint,weekTotal,weekTotalTxt,weekCount,weekPercent,expQuiz,expCross,expSearch, attends, attendAll} = this.state;
      const currentUrl = window.location.href;
      const structureData = {
         "@context": "https://schema.org",
         "@type": "WebSite",
         "name": "마이 포켓 - 지식포켓",
         "url": currentUrl,
      } 
      const allAttendComplete = Object.values(this.state.attends)
      .every(v => v.attend === true);   
      function getLeftExp(exp) {
         const lvl = getUserLevel(exp);
         if (lvl == 6) return 0;
         return LEVEL_TABLE[lvl].end + 1 - exp;
      }
      function getUserLevel(exp) {
         return Object.keys(LEVEL_TABLE).find(
            lvl => exp <= LEVEL_TABLE[lvl].end
         );
      }   
      function decodeHtmlEntities(str = "") {
         const txt = document.createElement("textarea");
         txt.innerHTML = str;
         return txt.value;
      }         
      const LEVEL_TABLE = {
         1: { name: "포켓 새싹", start: 0,     end: 2499,  msg: "포켓 새싹에 달성해보세요🚀" },
         2: { name: "포켓 루키", start: 2500,  end: 4999,  msg: "포켓 잎사귀에 달성해보세요🚀" },
         3: { name: "포켓 파이터", start: 5000,  end: 7499,  msg: "포켓 꽃에 달성해보세요🚀" },
         4: { name: "포켓 마스터", start: 7500,  end: 9999,  msg: "포켓 열매에 달성해보세요🚀" },
         5: { name: "포켓 히어로", start: 10000, end: 14999, msg: "지식포켓 전설에 달성해보세요🚀" },
         6: { name: "포켓 레전드", start: 15000, end: Infinity, msg: "대단해요! 당신을 지식포켓 전설로 인정합니다" },
      };    
  
      const leftExp = getLeftExp(expCurr);   
      const levelMsg = LEVEL_TABLE[userLvl].msg;
      return loading ? <LoadingSpinner /> : (
         <>
            <Helmet>

               <title>마이 포켓 - 지식포켓</title>
               <meta name="keywords" content="지식포켓, 뉴스 용어, 시사 용어, 오늘의 용어, 용어 검색, OX 퀴즈, 객관식 퀴즈, 십자말풀이, 시사 상식, 뉴스 해설, 용어 사전" />
               <meta name="description" content="나의 퀴즈 기록과 찜한 용어를 한눈에! 마이 포켓에서 학습 성취를 확인하고 꾸준히 성장해보세요."/>

               <meta property="og:type" content="website" />
               <meta property="og:site_name" content="지식포켓" />
               <meta property="og:title" content="마이 포켓 - 지식포켓" />
               <meta property="og:description" content="나의 퀴즈 기록과 찜한 용어를 한눈에! 마이 포켓에서 학습 성취를 확인하고 꾸준히 성장해보세요."/>
               <meta property="og:url" content={currentUrl} />
               <meta property="og:image" content="https://cwstatic.asiae.co.kr/pocket/og_img.png" /> 
               <meta property="og:image:width" content="1200" />
               <meta property="og:image:height" content="630" />
               <meta property="og:locale" content="ko_KR" />

               <link rel="canonical" href={currentUrl}/>
               <script type="application/ld+json">
               { JSON.stringify(structureData)}
               </script>               
               
            </Helmet>          
            <main id="contents" data-page="my" className="page--my no-search-btn">
               <div className="title-bx">
                  <div className="nickname">
                     <h1 className="tit"><span>{decodeHtmlEntities(userNick)} 님,</span> <span>마이 포켓</span></h1>
                     <button className="nickname__btn popup-link" type="button" title="닉네임 수정" data-popup="popup--rename"> </button>
                  </div>
                  <p className="desc">내 포켓 속 지식 기록을 확인해 보세요</p>
               </div>

               <section className="my-level">
                  <div className="level-img" data-level={userLvl}></div>
                  
                  <div className="level-name">
                     <p className="name">포켓 속 씨앗</p>
                     <p className="num"> <span>Lv. </span><span className="em">{userLvl}</span> </p>
                  </div>

                  <div className="level-gauge">
                     <span className="level-gauge__range level-gauge__range--start">{currStartExp.toLocaleString()}</span>
                     {userLvl < 6 ? (
                        <span className="level-gauge__range level-gauge__range--end">{nextStartExp.toLocaleString()}</span>
                     ): ( <></> )}
 
                     <div className="gauge">
                        <span className={`exp ${expPercent < 45 ? 'txt-in' : ''}`} data-max={gapLevel} data-min="0" data-exp={expCurr} style={{width:expPercent+'%'}}>
                        <i className="exp-num">{userLvl < 6 ? ( Number(expCurr).toLocaleString() ) : ( (Number(expCurr) + Number(currStartExp)).toLocaleString() )}Exp</i>
                        </span>
                     </div>
                  </div>

                  <div className="level-txt">
                     {userLvl < 6 ? (
                        <>
                           <p>다음 레벨까지 <span id="leftExp">{leftExp.toLocaleString()} Exp</span>! </p>
                           <p>{levelMsg}</p>
                        </>
                     ):(
                        <p>{levelMsg}</p>
                     )}
                  </div>
               </section>     
               <section className="my-quiz-history">
                  <div className="my-section__title">
                     <a href="/MyQuiz" className="tit">퀴즈 내역</a>
                     <p className="desc">이번 주 현황! 이대로라면 퀴즈 천재는 시간문제✌️</p>
                  </div>

                  <ul className="quiz-history-state">
                     <li className="box">
                        <p className="title">오늘의<em> 용어 퀴즈 </em></p>
                        <p className="count"> <em>{quizTotal}</em>회 </p>
                        <div className="state">
                           <div className="txt">
                              <p className="label">정답률</p>
                              <p className="num"><em>{quizPercent}</em>%</p>
                           </div>
                           <div className="gauge"><p className="gauge__bar" style={{width: quizPercent+'%'}}></p></div>
                        </div>
                        <p className="exp">{expQuiz}Exp 획득</p>
                     </li>
                     <li className="box">
                        <p className="title"> 주간<em> 십자말풀이 </em> </p>
                        <p className="count"> <em>{crossCount}</em>회 </p>
                        <div className="state">
                           <div className="txt">
                              <p className="label">정답률</p>
                              <p className="num"><em>{crossPercent}</em>%</p>
                           </div>
                           <div className="gauge"><p className="gauge__bar" style={{width: crossPercent+'%'}}></p></div>
                        </div>
                        <p className="exp">{expCross}Exp 획득</p>
                     </li>
                     <li className="box">
                        <p className="title"><em> 미니게임 </em>진행률</p>
                        <p className="count"> <em>{searchDateCnt}</em>회 </p>
                        <div className="state">
                           <div className="txt">
                              <p className="label">진행률</p>
                              <p className="num"><em>{searchPercent}</em>%</p>
                           </div>
                           <div className="gauge"><p className="gauge__bar" style={{width: searchPercent+'%'}}></p></div>
                        </div>
                        <p className="exp">{expSearch}Exp 획득</p>
                     </li>

                     <li className="box box--total">
                        <p className="title"> 이번 주 <em>성과</em> </p>
                        <p className="count"> <em>{weekTotalTxt}</em>회 </p>
                        <div className="state">
                           <div className="txt">
                              <p className="label">평균 정답률</p>
                              <p className="num"><em>{weekPercent}</em>%</p>
                           </div>
                           <div className="gauge"><p className="gauge__bar" style={{width: weekPercent+'%'}}></p></div>
                        </div>

                        <p className="exp">총 {weekPoint}Exp 획득</p>
                     </li>
                  </ul>
                  </section>

                  <section className="my-section">
                  <div className="container">
                     <div className="my-section__title">
                        <p className="tit">출석 체크</p>
                     </div>
                  </div>
                  <div className="attend-board__wrap">
                     <div className="attend-board">
                        {Object.keys(this.state.attends).map((key) => {
                           const item = this.state.attends[key];
                           const dayNum = key;
                           const dayYmd = item.date;

                           let classNames = ['btn'];
                           let btnExp = 10;

                           if (item.attend) classNames.push('active');
                           if (!item.attend && !item.today) classNames.push('off');

                           if (dayNum == 6 || dayNum == 7) {
                              classNames.push('btn--double');
                              btnExp = 20;
                           }

                           // 테스트주석
                           const canClick = item.today && !item.attend;

                           return (
                              <button
                                 key={dayNum}
                                 className={classNames.join(' ')}
                                 disabled={!canClick}
                                 onClick={() => this.onClickAttend(dayNum, dayYmd)}
                              >
                                 <p className="tit">
                                 Day<em className="em">{dayNum}</em>
                                 </p>
                                 <p className="exp">{btnExp}</p>
                              </button>
                           );
                        })}
                        <button
                           className={`btn btn--bonus ${
                              this.state.attendAll =='1'? 'active' : (allAttendComplete ? '' : 'off')
                           }`}
                           disabled={!allAttendComplete || this.state.attendAll == '1'}
                           onClick={this.onClickBonus}
                           >
                           <p className="tit">Bonus</p>
                           <p className="exp">10</p>
                        </button>                      
                     </div>
                  </div>
               </section>                         

               {(zzimList && zzimList.length > 0) ? (
                  <section className="my-section zzim-word">
                     <div className="container">
                        <div className="my-section__title">
                           <a href="/MyZzim" className="tit">찜한 용어</a>
                        </div>

                        <div className="wordSwiper">
                           <div className="swiper-container">
                              <div className="swiper-wrapper">
                                 {zzimList.slice(0, 10).map((item, index) => (
                                    <div className="swiper-slide item">
                                       <article className="word-card">
                                          <button id={`btn-${item.idx}`} type="button" className={item.uzzim ? 'zzim active' : 'zzim'} onClick={(e) => {
                                             e.preventDefault();
                                             e.stopPropagation();
                                             if (this.isDragging) return; // 스와이프 중이면 무시
                                             this.handleButtonClick(item.idx)
                                          }}>
                                             <svg width="24" height="22" id={`svg-${item.idx}`} viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg" fillOpacity="0">
                                                <use xlinkHref="#zzim"></use>
                                             </svg>
                                             <span className="sr-only">찜하기 해제</span>
                                          </button>
                                          <a href={item ? `/View/${item.idx}` : '#'} className="wrap">
                                             <p className="tit">
                                                <span>{item.title}</span>
                                             </p>
                                             <p className="eng">{item.subtitle}</p>
                                          </a>
                                       </article>
                                    </div>
                                 ))}
                              </div>
                           </div>
                        </div>
                     </div>
                  </section>

               ) : (
                  <section className="my-section zzim-word">
                     <div className="container">
                        <div className="my-section__title">
                           <p className="tit">찜한 용어</p>
                        </div>
                        <div className="word-null">
                           <p>찜한 용어가 없어요 😥</p>
                           <a className="btn" href="/WordList">용어 리스트 보기</a>
                        </div>
                     </div>
                  </section>
               )}


               <div className="container">
                  <button className="btn-logout" type="button" onClick={() => this.handleLogoutClick()}>
                     로그아웃
                  </button>
               </div>
            
            </main >
          
            <Footer />
            <aside
               ref={el => (this.popupEl = el)}
               className="wordquiz__popup" >
               ✨ <span ref={el => (this.popupTextEl = el)}>+0</span> Exp
            </aside>               
            <aside className="popup rename__popup" id="popup--rename">
               <div className="popup__wrap">
               <div className="popup__head">
                  <button type="button" className="popup__close"><span className="sr-only">닫기</span></button>
               </div>
               <p className="tit">닉네임 수정</p>
               <form onSubmit={this.setUserNick}>
                  <div className="input-bx">
                     <input type="text" id="nickname" placeholder={decodeHtmlEntities(userNick)} onChange={this.onChangeNick} value={this.state.newNick} autocomplete="off" maxLength={10}/>
                     <p className="input-bx__length"> <span id="curLen">{this.state.newNick.length}</span>/<span id="maxLen">10</span> </p>
                  </div>
                  <button type="submit" className="btn"> 수정 </button>
               </form>
               </div>
            </aside>              
         </>
      );
   }
}
async function setWord(md, idx) {
   const publicUrl = process.env.REACT_APP_POCKET_WWW;
   setCookie('JUMP_URI', publicUrl);
   try {
      const response = await axios.get('/api/setWord.php?md=' + md + '&idx=' + idx);
      if (response.data == 'NO') {
         window.location.href = loginUrl;
      }
      return response.data;
   } catch (error) {
      console.log(error.message);
      return false;
   };
}
export default withRouter(My);